<div #imageEdit (update)="newResult()"></div>
<div class="zoom-buttons">
  <button type="button" (click)="zoomOut()" class="zoom-button-out">-</button>
  <button type="button" (click)="zoomIn()" class="zoom-button-in">+</button>
</div>
